import { Component, Input } from "@angular/core";
import { IconComponent } from "../../atoms/icon/icon.component";
import { StepperService } from "../../../services/stepper.service";
import { prefixClass, STEP_HEADER_TITLE } from "../../../../core/constants/constants";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'app-step-header',
    templateUrl: './step-header.component.html',
    styleUrls: ['./step-header.component.scss'],
    imports: [IconComponent, CommonModule], 
    standalone: true   
})
export class StepHeaderComponent {
    @Input() showBackButton: boolean = true;
    @Input() showIconAction: boolean = false;
    @Input() iconActionClick: ($event: any) => void = () => {};
    title: string = '';
    isMobile : boolean;
    prefixClass: string = prefixClass;

    constructor(private stepperService: StepperService) {
        this.isMobile = window.innerWidth <= 768;
    }

    ngOnInit(): void {
        const currentStepID = this.stepperService.getCurrentStep()?.id ?? 0;
        if (currentStepID) {
            this.title = STEP_HEADER_TITLE[currentStepID]
        }
    }

    goBack(): void {
        this.stepperService.previousStep();
    }
}